import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  authUser: {
    auth: false,
    authType: false,
    user: {},
    loginUserDetail: {},
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
